import PropTypes from 'prop-types';
import {Box, Button, TextField, Typography} from '@mui/material';
import Grid from '@mui/material/Grid';
import {useRef} from 'react';
import {useTranslation} from 'react-i18next';

export default function EnterPlayerDisplayNameStep({
  nextStep,
  previousStep,
  handleChange,
  workFlowData,
}) {
  const {t} = useTranslation();

  const displayNameFieldRef = useRef();

  const InputWithNoSpaces = (e) => {
    if (e.key === ' ') {
      e.preventDefault();
    }
  };

  function onSubmit(e) {
    e.preventDefault();
    handleChange({displayName: displayNameFieldRef.current.value});
    nextStep();
  }

  function saveChangesAndGoBack() {
    handleChange({displayName: displayNameFieldRef.current.value});
    previousStep();
  }

  return (
    <div>
      <Typography variant="h2" gutterBottom marked="center" align="center">
        {t('display-name-title')}
      </Typography>
      <Box component="form" onSubmit={onSubmit} sx={{mt: 6}}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              inputRef={displayNameFieldRef}
              label={t('display-name-label')}
              autoFocus
              fullWidth
              margin="normal"
              name="DisplayName"
              inputProps={{maxLength: 14}}
              type="text"
              required
              onKeyDown={InputWithNoSpaces}
              size="large"
              defaultValue={workFlowData.displayName}
            />
          </Grid>
          <Grid item xs={12}>
            <Box>
              <Typography sx={{fontWeight: 'bold', fontStyle: 'oblique'}}>
                * {t('display-name-info-text')}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Button
              onClick={saveChangesAndGoBack}
              fullWidth
            >
              {t('back-button')}
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              type="submit"
              fullWidth
            >
              {t('next-button')}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
EnterPlayerDisplayNameStep.propTypes = {
  nextStep: PropTypes.func.isRequired,
  previousStep: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  workFlowData: PropTypes.any.isRequired,
};
